import type { Components } from '@mui/material/styles';

export default function MUIStepButton(): Components['MuiStepButton'] {
  return {};
}
